module.exports = __webpack_public_path__ + "img/4.9864baba.jpg";